import React from "react"
import { apiStoredProcedures } from "@services/CCMAccess/apiAccess"
import { CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetValidCampaignCodesResult } from "@utils/apis/ccm/model"
import { temp } from "../interfaces/interfaces"
import { logger } from "@services/workers/helpers"

const fetchPromoCodes = async () => {
    try {
        logger.debug("REACT", "useCCPromoCodes->fetchPromoCodes", "Fetching Promo Codes")
        const result = await apiStoredProcedures.getApiStoredProceduresSpServiceAgreementsGetValidCampaignCodes()
        temp.AvailablePromoCodes = result
        return result
    }
    catch (error) {
        logger.error("REACT", "useCCPromoCodes->fetchPromoCodes", error)
    }
}

type PromoCodes = CareClubCCMAPIModelsStoredProceduresSpServiceAgreementsGetValidCampaignCodesResult;

export const useCCPromoCodes = () => {
    const [promoCodes, setPromoCodes] = React.useState<PromoCodes[]>([])

    React.useEffect(() => {
        fetchPromoCodes().then((response) => {
            response && setPromoCodes(response)
        })
    }, [])

    return promoCodes
}